import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHouse = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m17.134 8.49-6.25-6.25a1.25 1.25 0 0 0-1.768 0l-6.25 6.25a1.24 1.24 0 0 0-.366.885v7.5a.625.625 0 0 0 .625.625h5a.625.625 0 0 0 .625-.625V12.5h2.5v4.375a.625.625 0 0 0 .625.625h5a.625.625 0 0 0 .625-.625v-7.5a1.24 1.24 0 0 0-.366-.884m-.884 7.76H12.5v-4.375a.624.624 0 0 0-.625-.625h-3.75a.625.625 0 0 0-.625.625v4.375H3.75V9.375L10 3.125l6.25 6.25z"
	})
});
export default SvgHouse;
